// SemanticUI-free pre-@plone/components
import { useEffect, useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import logoSAWFull from './SAW-Logo_farbig-positiv_RGB.svg';
import logoSAWSmall from './SAW-Logo_farbig-negativ_RGB.svg';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import { Link } from 'react-router-dom';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import Image from '@plone/volto/components/theme/Image/Image';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import MobileNavigation from '../MobileNavigation/MobileNavigation';
import { defineMessages, useIntl } from 'react-intl';
import type { Content } from '@plone/types';
import config from '@plone/volto/registry';
import globalmessages from '../../messages';

type FormState = {
  content: {
    data: Content;
  };
  navroot: {
    data: {
      navroot: Content;
    };
  };
  form: {
    global: Content;
  };
};

const messages = defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'home',
  },
});

const CustomHeader = ({ pathname, content, isScrolled }) => {
  const [isClient, setIsClient] = useState(false);
  const lang = useSelector((state) => state.intl.locale);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const Container = config.getComponent({ name: 'Container' }).component;
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <>
      <Container>
        <div className="header">
          <div className="header-tools">
            <div className="tools-wrapper">
              <div className="search-wrapper navigation-desktop">
                <div className="search">
                  <SearchWidget />
                </div>
              </div>
              <div className="tools">
                {lang === 'de' && (
                  <>
                    <UniversalLink href="/de/leichte-sprache">
                      {intl.formatMessage(globalmessages.leichteSprache)}
                    </UniversalLink>
                    <UniversalLink href="/de/barrierefreiheit/angebote-in-gebaerdensprache">
                      {intl.formatMessage(globalmessages.gebaerdensprache)}
                    </UniversalLink>
                  </>
                )}
                <LanguageSelector />
              </div>
            </div>
          </div>
          <div className="custom-header">
            <div className="fill-header left"></div>
            <div className="header-content">
              <div className="logo-container">
                <Link to="/" aria-label={intl.formatMessage(messages.home)}>
                  <Image
                    className="logo saw-logo"
                    src={logoSAWFull}
                    alt="logo"
                  />
                </Link>
              </div>
              <Navigation pathname={pathname} className="header-nav" />
              <MobileNavigation pathname={pathname} />
              {isScrolled && (
                <div className="search-wrapper">
                  <div className="search">
                    <SearchWidget />
                  </div>
                </div>
              )}
            </div>
            <div className="fill-header right"></div>
          </div>
        </div>
      </Container>
    </>
  );
};

const Header = (props) => {
  const { pathname } = props;
  const [isScrolled, setScrolled] = useState(false);
  const content = useSelector<FormState, Content>(
    (state) => state.content.data,
    shallowEqual,
  );

  const navRoot = useSelector<FormState, Content>(
    (state) => state.navroot?.data?.navroot,
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
      <header
        className={`header-wrapper sticky-header ${isScrolled && 'header-scrolled'} ${!isScrolled && 'unscrolled'}`}
      >
        <CustomHeader
          pathname={pathname}
          content={content}
          isScrolled={isScrolled}
        />
      </header>
      <SlotRenderer name="belowHeader" content={content} navRoot={navRoot} />
    </>
  );
};

export default Header;
